export default __webpack_public_path__ + "static/media/home-page-6.96d7a824.jpg";